import moment from "moment";

export const getDateYYYYMMDD = (isoDate) => {
  return moment(isoDate).format("YYYY-MM-DD");
};

//23 march 2024

export const getDDMonthYYYY = (dateString) => {
  if (!dateString) {
    return;
  }
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.toLocaleString("default", { month: "short" });
  const year = date.getFullYear();
  return `${day} ${month} ${year}`;
};
